import { createSlice } from "@reduxjs/toolkit";
import { RESET_STORE } from "./actionTypes";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isLoggedIn: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    updateUserDetails: (state, action) => {
      if (state.user) {
        state.user = {
          ...state.user,
          ...action.payload,
        };
      }
    },
    logoutUser: (state) => {
      state.user = null;
      state.isLoggedIn = false;
    },
  },
});

export const { setUser, updateUserDetails, logoutUser } = authSlice.actions;

export default authSlice.reducer;

export const registerUser = (userData) => async (dispatch) => {
  try {
    dispatch(setUser(userData));
  } catch (error) {
    console.error("Registration failed:", error.message);
    throw error;
  }
};

export const loginUser = (userData) => async (dispatch) => {
  try {
    dispatch(setUser(userData));
  } catch (error) {
    console.error("Login failed:", error.message);
    throw error;
  }
};

// Logout user
export const logout = () => async (dispatch) => {
  try {
    // Facebook logout if FB SDK is available
    if (window.FB) {
      window.FB.getLoginStatus(function (response) {
        if (response.status === "connected") {
          // window.FB.logout(function (logoutResponse) {
          //   console.log("Facebook user logged out:", logoutResponse);
          // });
        }
      });
    }

    // Clear local app data
    localStorage.clear();
    dispatch(logoutUser());
    dispatch({ type: RESET_STORE });

    return Promise.resolve();
  } catch (error) {
    console.error("Logout failed:", error.message);
    return Promise.reject(error);
  }
};
